<template>
    <div class="modal fade" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content loading">
                <div align="center">
                    <div class="loader-back">
                        <div class="loader"></div>
                    </div>
                </div>
                <div align="center">
                    <p class="letter-loading">{{ title }}</p>
                </div>
            </div>                    
        </div>
    </div>
</template>
<script>
export default {
    name:'modal-send',
    props:{
        idModal:String,
        title:String
    },
    mounted(){
        // this.initModal()
    },
    methods:{
        initModal(){
            $('.modal').modal({
                keyboard: false,
                show:false,
                backdrop:'static'
            });
        },
        stopModal(){
            $('#'+this.idModal).modal('hide');
        },
        setTimeModal(){
            setTimeout(()=>{
                this.stopModal();
            }, 10000);
        }
    }
}
</script>
<style>
.loading{
    background:transparent;
    border:none;
}
.container-loading{
    width:145px;
    height:145px;
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid white;
  border-bottom: 16px solid white;
  border-left: 16px solid blue;
  border-right: 16px solid blue;
  width: 145px;
  height: 145px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

.loader-back{
    
    border-radius: 50%;
    
    background-image: url("../../assets/images/load_dgcp.png");
    width:148px;
    height:148px;
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover;
    background-position: center; 
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.letter-loading {      
      font-family: arial;
      font-style: italic;
      
      width:100%;
      
      margin: 0 auto;
      text-align: center;
      
      color:white;
      font-size:15px;
      font-weight: bold;
      position: absolute;
      -webkit-animation:colorchange 20s infinite alternate;      
      animation:colorchange 20s infinite alternate;      
    }

    @-webkit-keyframes colorchange {
      0% {        
        color:white;
      }      
      10% {        
        color: red;
      }      
      20% {        
        color: yellow;
      }      
      30% {        
        color:green;
      }      
      40% {        
        color:white;
      }      
      50% {        
        color: #2980b9;
      }      
      60% {        
        color:red;
      }      
      70% {        
        color: yellow;
      }
      80% {     
        color: green;
      }      
      90% {     
        color: #2980b9;
      }      
      100% {        
        color: white;
      }
    }

    @keyframes colorchange {
      0% {        
        color:white;
      }      
      10% {        
        color: red;
      }      
      20% {        
        color: yellow;
      }      
      30% {        
        color:green;
      }      
      40% {        
        color:white;
      }      
      50% {        
        color: #2980b9;
      }      
      60% {        
        color:red;
      }      
      70% {        
        color: yellow;
      }
      80% {     
        color: green;
      }      
      90% {     
        color: #2980b9;
      }      
      100% {        
        color: white;
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/modal/modalLoading.vue